import styled from 'styled-components';
import { MediaQuery, NeutralColors } from 'theme';

const FailedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const ContentLayout = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  height: 100%;

  @media (max-width: ${MediaQuery.screenSizesCss.phone}) {
    flex-direction: column;
    overflow-y: auto;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 auto 24px auto;
`;

const LeftContent = styled.div`
  flex: 1;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: ${MediaQuery.screenSizesCss.phone}) {
    padding: 24px 16px;
  }
`;

const SceneImage = styled.div`
  width: 70%;
  height: 250px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 8px;
  overflow: hidden;
`;

const RightContent = styled.div`
  width: 460px;
  background-color: ${NeutralColors[10]};
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;

  @media (max-width: ${MediaQuery.screenSizesCss.phone}) {
    width: 100%;
    padding: 24px 16px;
    overflow-y: visible;
  }
`;

export {
  ContentLayout,
  FailedWrapper,
  ImageContainer,
  LeftContent,
  RightContent,
  SceneImage,
};
